<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div class="topbar">
    <!--begin::Search-->
    <!--<KTQuickSearch></KTQuickSearch>-->
    <!--end::Search-->


    <!--begin::Notifications-->

   <!-- <b-dropdown
      size="sm"
      variant="link"
      toggle-class="topbar-item text-decoration-none"
      no-caret
      right
      no-flip
    >
      <template v-slot:button-content>
        <div
          class="btn btn-icon btn-clean btn-dropdown btn-lg mr-1 pulse pulse-primary"
        >
          <span class="svg-icon svg-icon-xl"
            ><i class=" flaticon2-notification icon-lg"></i
          ></span>
        </div>
      </template>
      <b-dropdown-text tag="div" class="min-w-md-350px">
        <form>

          <div
            class="d-flex flex-column pt-8 pb-8 bgi-size-cover bgi-no-repeat rounded-top"
            :style="{ backgroundImage: `url(${notificationBg})` }"
          >

            <h4 class="d-flex flex-center rounded-top">
              <span class="text-white"> {{ $t("topbar.notification_user") }}</span>
              <span
                class="btn btn-text btn-success btn-sm font-weight-bold btn-font-md ml-2"
                >0</span
              >
            </h4>

          </div>



          <div class="tab-content">

            <div
              class="tab-pane active show p-8"
              id="topbar_notifications_notifications"
              role="tabpanel"
            >

              <div
                class="scroll pr-7 mr-n7"
                data-scroll="true"
                data-height="300"
                data-mobile-height="200"
              ></div>

            </div>

          </div>

        </form>
      </b-dropdown-text>
    </b-dropdown>
   -->



    <!--begin::Chat-->
    <div class="topbar-item mr-5">
      <a href="../notifications" class="btn btn-icon btn-clean btn-lg">
        <span class="svg-icon svg-icon-xl">
          <i class="flaticon2-chat icon-lg"></i> </span
      ></a>
    </div>
    <!--end::Chat-->

    <!--begin::Languages-->
    <div class="topbar-item">
      <b-dropdown
        size="sm"
        variant="link"
        toggle-class="btn btn-icon btn-clean btn-dropdown btn-lg mr-1 text-decoration-none"
        no-caret
        right
        no-flip
      >
        <template v-slot:button-content>
          <img
            class="h-20px w-20px rounded-sm"
            :src="languageFlag || getLanguageFlag"
            alt=""
          />
        </template>
        <b-dropdown-text tag="div" class="min-w-md-175px">
          <KTDropdownLanguage
            v-on:language-changed="onLanguageChanged"
          ></KTDropdownLanguage>
        </b-dropdown-text>
      </b-dropdown>
    </div>
    <!--end::Languages-->

    <!--begin::User-->
    <KTQuickUser></KTQuickUser>
    <!--end::User-->
  </div>
</template>

<style lang="scss">
.topbar {
  .dropdown-toggle {
    padding: 0;
    &:hover {
      text-decoration: none;
    }

    &.dropdown-toggle-no-caret {
      &:after {
        content: none;
      }
    }
  }

  .dropdown-menu {
    margin: 0;
    padding: 0;
    outline: none;
    .b-dropdown-text {
      padding: 0;
    }
  }
}
</style>

<script>
import KTQuickUser from "@/view/layout/extras/offcanvas/QuickUser";
//import KTQuickSearch from "@/view/layout/extras/offcanvas/QuickSearch";
//import KTDropdownNotification from "@/view/layout/extras/dropdown/DropdownNotification.vue";
//import KTDropdownQuickAction from "@/view/layout/extras/dropdown/DropdownQuickAction.vue";
import i18nService from "@/core/services/i18n.service.js";
import KTDropdownLanguage from "@/view/layout/extras/dropdown/DropdownLanguage.vue";

export default {
  name: "Topbar",
  components: {
    KTQuickUser,
    KTDropdownLanguage
    //KTQuickSearch,
    //KTDropdownNotification,
    //KTDropdownQuickAction
  },
  data() {
    return {
      languageFlag: "",
      languages: i18nService.languages
    };
  },
  methods: {
    onLanguageChanged() {
      this.languageFlag = this.languages.find(val => {
        return val.lang === i18nService.getActiveLanguage();
      }).flag;
    }
  },
  computed: {
    notificationBg() {
      return process.env.BASE_URL + "media/misc/bg-1.jpg";
    },
    getLanguageFlag() {
      return this.onLanguageChanged();
    }
  }
};
</script>
